export const thresholdValue = (state) => state.thresholdConfigData;

export const getSelectedTaskDetails = (state) => state.selectedTaskDetails;

export const getAllTasks = (state) => state.allTasks;
export const getStatsInfoPerProcess = (state) => state.statsInfoPerProcess;
export const getDataModelFilter = (state) => state.dataModelFilter;

export const getInitialDiagramData = (state) => state.initialDiagramData;

export const getAllDataModelList = (state) => state.allDataModelList;

export const getFiltredTasks = (state) => state.filtredTasks;

export const getTaskDetailsById = (state) => state.taskDetailsById;

export const turaroundTypes = state => state.turaroundTypes;
export const getThresholds = state => state.defaultThresholds;

export const filterObject = (state) => state.filterObject;

export const getSelectedProcessReports = (state) => state.selectedProcessReports;

export const getSelectedProcessStatistics = (state) => state.selectedProcessStatistics;

export const nrOfFilteredResults = (state) => state.nrOfFilteredResults;

export const searchInSearchFilter = (state) => state.searchInSearchFilter;

export const currentPluginData = (state) => state.currentPluginData;

export const getStatsPerLevels = (state) => state.statsPerLevels;

export const getFilteredData = (state) => state.filteredData;

export const getAppMatrixUncompletedTasks = (state) => state.appMatrixUncompletedTasks;
export const getNrOfResults = (state) => state.nrOfResults;

export const getDataToExport = (state) => state.dataToExport;
